import type { RouteRecordRaw, Router } from 'vue-router'

const DonationContractRoutes: RouteRecordRaw = {
  path: '/contract/financial/donation',
  name: 'DonationModulePages',
  redirect: { name: '' },
  children: [
    {
      path: '',
      name: 'DonationMainRoute',
      component: () => import('./views/AccordView.vue'),
      meta: {
        title: 'donation.donationContract',
      },
    },
    {
      path: 'create',
      name: 'DonationCreateRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'donation.createDonationContract',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:accordId',
      name: 'DonationEditRoute',
      component: () => import('./views/AccordUpsertView.vue'),
      meta: {
        title: 'donation.editDonationContract',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:accordId',
      name: 'ViewDonationRoute',
      component: () => import('./views/SingleAccordView.vue'),
      meta: {
        title: 'donation.ViewDonation',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(DonationContractRoutes)
}
